/*
 * @Author: Claude
 * @Date: 2025-11-15
 * @Description: 媒体时长校验
 */
import { t } from '@/utils/helper/intl';

import { FileUploadRule } from '../types/validator';
import { formatDuration, getMediaDuration } from '../utils/getMediaDuration';

/**
 * 校验媒体文件时长
 * @param file - 待校验的文件
 * @param rule - 校验规则
 * @returns Promise<string | null> - 错误信息或 null
 */
export const validateMediaDuration = async (
  file: File,
  rule: FileUploadRule,
): Promise<string | null> => {
  const { minDuration, maxDuration, message } = rule;

  if (minDuration === undefined && maxDuration === undefined) {
    return null;
  }

  try {
    const duration = await getMediaDuration(file);

    if (minDuration !== undefined && duration < minDuration) {
      return (
        message ||
        t('minDuration-currentDuration', {
          minDuration: formatDuration(minDuration),
          currentDuration: formatDuration(duration),
        })
      );
    }

    if (maxDuration !== undefined && duration > maxDuration) {
      return (
        message ||
        t('maxDuration-currentDuration', {
          maxDuration: formatDuration(maxDuration),
          currentDuration: formatDuration(duration),
        })
      );
    }

    return null;
  } catch (error) {
    return `${error instanceof Error ? error.message : t('merror.httpError.12301000')}`;
  }
};
